import { useEffect, useState } from "react";
import LoadingBoundary from "../../../components/LoadingBoundary";
import Tableau from "../../../components/tableau/Tableau";
import { Message } from "../../../services/Api/swagger";
import MessagesForm from "../MessagesForm";
import { messagesTableauHeader } from "./tableauHeader";
import { useQueryClient } from "react-query";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Snackbar,
  Typography,
} from "@mui/material";
import { useMessages } from "./selectors";
import Snack from "../../../components/Snack";

function TableauMessages() {
  const queriesClient = useQueryClient();

  const {
    errorDeleteMessage,
    isFetchingMessages,
    useRechercherMessages,
    isSuccessDeleteMessage,
    errorMessages,
    searchResults,
    open,
    handleConsulter,
    handleConfirm,
    handleDelete,
    selectedId,
    setOpen,
    setSelectedId,
    openConfirm,
    resetDeleteMutation,
    setOpenConfirm,
  } = useMessages();

  return (
    <>
      <LoadingBoundary
        loading={isFetchingMessages}
        error={errorMessages}
        onRetry={useRechercherMessages}
      >
        <>
          <Tableau
            onConsulter={handleConsulter}
            donneesTableau={searchResults}
            alerteEnCoursSuppression={false}
            headerDonnees={messagesTableauHeader}
            type="messages"
            trierPar={"asc"}
            ordreDeTrie={"asc"}
            onTrier={() => {}}
            isPaginer={false}
            page={1}
            nbrElementTotal={2}
            nbrElementParPage={5}
            onChangerPage={() => {}}
            onChangerNbrResultatParPage={() => {}}
            onDelete={handleDelete}
            onGenerer={() => {}}
          />
          {searchResults?.length === 0 && (
            <Typography variant="body2">Aucun message trouvé</Typography>
          )}
        </>
      </LoadingBoundary>
      {selectedId && (
        <MessagesForm
          open={open}
          onClose={() => setOpen(false)}
          resetId={() => setSelectedId(undefined)}
          selectedId={selectedId}
        />
      )}
      <Dialog open={openConfirm} aria-labelledby="confirm-dialog">
        <DialogTitle id="confirm-dialog">
          {"Etes vous sur de vouloir supprimer ce dossier ?"}
        </DialogTitle>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => setOpenConfirm(false)}
            color="secondary"
          >
            Annuler
          </Button>
          <Button variant="contained" onClick={handleConfirm} color="primary">
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>
      {isSuccessDeleteMessage && (
        <Snack
          open={isSuccessDeleteMessage}
          variant="success"
          message="Votre message a bien été supprimé"
          onClose={() => {
            resetDeleteMutation();
          }}
        />
      )}
    </>
  );
}

export default TableauMessages;
